module.exports = __webpack_public_path__ + "static/img/img_wsj@2x.63da47fe.png";